import {Colour} from '@taopix/taopix-core';
import {IntColour, HexColour} from '@taopix/taopix-core/dist/types/types';

const getSafeColour = (colour: IntColour) => {
  return (Colour.int2Hex(colour) as HexColour).replace('#', '');
};

export {getSafeColour};
